// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__etDEb","title":"Hero_title__eQTxz","subtitle":"Hero_subtitle__5GT2s"};